import React, { ReactNode } from "react";
import { useState } from "react";
import { Flex } from "../compositeComponents/FlexHelpers";
import { AnimatedCollapsibleContent } from "./AnimatedCollapsibleContent";
import { CollapsiblePanelHeader } from "./CollapsiblePanelHeader";

export type CollapsiblePanelProps = {
    openHeader?: ReactNode,
    closedOrDefaultHeader: ReactNode,
    children: ReactNode,
    defaultOpen?: boolean,
    headerAlignment?: 'flex-start' | 'space-between' | 'flex-end',
    eagerRender?:boolean
}

export function CollapsiblePanel(props: CollapsiblePanelProps): JSX.Element {

    const [isOpen, setIsOpen] = useState(props.defaultOpen || false);
    
    React.useEffect(() => {
        setIsOpen(props.defaultOpen ?? false);
    }, []);

    return (
        <Flex flexDirection="column">
            
            <CollapsiblePanelHeader {...props} isOpen={isOpen} onChangeOpenState={setIsOpen} />

            <AnimatedCollapsibleContent open={isOpen} eagerRender={props.eagerRender}>
                {props.children}
            </AnimatedCollapsibleContent>
        </Flex>
    )
}